ceregoCommon.factory('UserMetricsResource', ['$resource', ($resource) ->
  $resource "", {},
    index:
      method: 'GET'
      url: APIRoutes.v3_user_metrics_path()
])
